import { RecentProcurementsDataGet } from '../../../adapter';

export default async function HandleRecentProcurementsDataGet(event) {
    const { size, page, search } = event;

    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/form/get';

    const payload = {
        data: {
            procurementFormData: {
                size: size,
                page: page,
                search: search
            },
            signature: ''
        }
    };

    const result = await RecentProcurementsDataGet(requestUrl, JSON.stringify(payload));
    return result;
}
